import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'avatarInitials',
  pure: true // This makes it a pure pipe for better performance
})
export class AvatarInitialsPipe implements PipeTransform {
  transform(name: string): string {
    if (!name || name.length === 0) {
      return '??';
    }
    
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  }
}
